import './ccf-call-keypad-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfCallKeypadIconProps extends SvgIconProps {}

/**
 * Component displays keypad  svg icon 
 * @param props -CcfCallKeypadIconProps
 * @returns keypad svg icon
 * @example - <CcfCallKeypadIcon/>
 */
export function CcfCallKeypadIcon(props: CcfCallKeypadIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="Keypad">
    <rect width="20" height="20" fill="#fff"/>
    <g id="Group_118187" data-name="Group 118187" transform="translate(-576 -209)">
      <g id="Rectangle_80258" data-name="Rectangle 80258" transform="translate(574 207)" stroke="#707070" strokeWidth="1" opacity="0">
        <rect width="24" height="24" stroke="none"/>
        <rect x="0.5" y="0.5" width="23" height="23" fill="none"/>
      </g>
      <g id="ivr-dialer" transform="translate(576 209)">
        <path id="Path_20" data-name="Path 20" d="M-40.728,78h-2.9a1.464,1.464,0,0,0-1.449,1.449v2.9a1.464,1.464,0,0,0,1.449,1.449h2.9a1.464,1.464,0,0,0,1.449-1.449v-2.9A1.464,1.464,0,0,0-40.728,78Z" transform="translate(45.076 -77.996)"/>
        <path id="Path_21" data-name="Path 21" d="M-35.491,77.958h-2.9a1.464,1.464,0,0,0-1.449,1.449v2.9a1.464,1.464,0,0,0,1.449,1.449h2.9a1.464,1.464,0,0,0,1.449-1.449v-2.9A1.464,1.464,0,0,0-35.491,77.958Z" transform="translate(47.085 -77.958)"/>
        <path id="Path_22" data-name="Path 22" d="M-30.544,77.92h-2.609A1.464,1.464,0,0,0-34.6,79.369v2.9a1.464,1.464,0,0,0,1.449,1.449h2.609a1.464,1.464,0,0,0,1.449-1.449v-2.9A1.464,1.464,0,0,0-30.544,77.92Z" transform="translate(49.095 -77.92)"/>
        <path id="Path_23" data-name="Path 23" d="M-40.69,83.233h-2.9a1.464,1.464,0,0,0-1.449,1.449v2.9a1.464,1.464,0,0,0,1.449,1.449h2.9a1.464,1.464,0,0,0,1.449-1.449v-2.9A1.464,1.464,0,0,0-40.69,83.233Z" transform="translate(45.038 -75.987)"/>
        <path id="Path_24" data-name="Path 24" d="M-35.453,83.2h-2.9A1.464,1.464,0,0,0-39.8,84.644v2.9a1.464,1.464,0,0,0,1.449,1.449h2.9A1.464,1.464,0,0,0-34,87.543v-2.9A1.464,1.464,0,0,0-35.453,83.2Z" transform="translate(47.047 -75.949)"/>
        <path id="Path_25" data-name="Path 25" d="M-30.506,83.157h-2.609a1.464,1.464,0,0,0-1.449,1.449v2.9c0,.789.37,1.448,1.159,1.449h2.9A1.464,1.464,0,0,0-29.057,87.5v-2.9A1.464,1.464,0,0,0-30.506,83.157Z" transform="translate(49.057 -75.911)"/>
        <path id="Path_26" data-name="Path 26" d="M-40.652,88.47h-2.9c-.789,0-1.448.37-1.449,1.159v2.9a1.464,1.464,0,0,0,1.449,1.449h2.9A1.464,1.464,0,0,0-39.2,92.528v-2.9C-39.2,88.84-39.863,88.472-40.652,88.47Z" transform="translate(45 -73.977)"/>
        <path id="Path_27" data-name="Path 27" d="M-35.415,88.432h-2.9c-.789,0-1.448.37-1.449,1.159v2.9a1.464,1.464,0,0,0,1.449,1.449h2.9a1.464,1.464,0,0,0,1.449-1.449V89.881A1.464,1.464,0,0,0-35.415,88.432Z" transform="translate(47.009 -73.939)"/>
        <path id="Path_28" data-name="Path 28" d="M-30.468,88.394h-2.9c-.789,0-1.158.66-1.159,1.449v2.609c0,.789.37,1.448,1.159,1.449h2.9a1.464,1.464,0,0,0,1.449-1.449V89.843A1.464,1.464,0,0,0-30.468,88.394Z" transform="translate(49.019 -73.901)"/>
      </g>
    </g>
  </g>
    </SvgIcon>
  );
}

export default CcfCallKeypadIcon;
